/**
 *
 * @param {{ method: string, manufacturingPlant: string, receivingPlant: string }} productionMethod
 * @returns {}
 */
export const buildProductionMethod = function (productionMethod) {
  let method = productionMethod ? productionMethod.Case : "";
  let manufacturingPlant = "";
  let receivingPlant = "";
  switch (method) {
    case "Make":
      manufacturingPlant = buildPlant(
        productionMethod.Fields[0].Value.Fields[0]
      );
      break;
    case "Both":
      manufacturingPlant = buildPlant(
        productionMethod.Fields[0].Value.Fields[0]
      );
      receivingPlant = buildPlant(productionMethod.Fields[0].Value.Fields[0]);
      break;
    case "Purchase":
    case "OEMDirectedPurchase":
      receivingPlant = buildPlant(productionMethod.Fields[0].Value.Fields[0]);
      break;
    case "Interplant":
      manufacturingPlant = buildPlant(
        productionMethod.Fields[0].Value.Fields[0]
      );
      receivingPlant = buildPlant(productionMethod.Fields[1].Value.Fields[0]);
      break;
    default:
    // do nothing
  }

  return { method, manufacturingPlant, receivingPlant };
};

export const buildPlant = function (plant) {
  let plantNumber = "";
  let entityName = "";
  let divisionName = "";

  if (plant && plant.Entity) {
    plantNumber = plant.Number.Fields[0];
    entityName =
      plant.Entity.Name.Fields[0] != null ? plant.Entity.Name.Fields[0] : "";
    divisionName =
      plant.Entity.Division.Name.Fields[0] != null
        ? plant.Entity.Division.Name.Fields[0]
        : "";
  } else if (plant) {
    plantNumber = plant.Fields[0];
  }

  return { plantNumber, entityName, divisionName };
};
